import { render, staticRenderFns } from "./ping.vue?vue&type=template&id=b2f8167c&scoped=true&"
import script from "./ping.vue?vue&type=script&lang=js&"
export * from "./ping.vue?vue&type=script&lang=js&"
import style0 from "./ping.vue?vue&type=style&index=0&id=b2f8167c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f8167c",
  null
  
)

export default component.exports